export default __webpack_public_path__ + "static/web-background-eae0011c23e3dffe6e9f9aff8d7efd91.jpg";